<div class="container">
  <div
    class="selected-items-header"
    [ngClass]="{ hide: hide }"
  >
    {{ header | uppercase }}
  </div>
  <div
    id="visionboard-workspace-selected-items-tutorial-target"
    class="border"
    [ngClass]="{ dragging: dragging, allowDrop: allowDrop, hide: hide }"
  >
    <div
      id="visionboard-workspace-selected-items"
      class="visionboard-workspace-selected-items"
    >
      <div
        id="visionboard-workspace-selected-items-drop-here"
        class="drop-here"
        [ngClass]="{ allowDrop: allowDrop, forceDropHereMessage: forceDropHereMessage, hideItems: hideItems }"
      >
        {{ dropHereMessage | uppercase }}
      </div>
      <app-visionboard-workspace-item
        *ngFor="let item of items; trackBy: trackWorkspaceItemsFn"
        class="visionboard-workspace-item"
        id="visionboard-workspace-item-{{ item.internalId }}"
        [item]="item"
        cdkDrag
        [cdkDragData]="item"
        [cdkDragFreeDragPosition]="item.location"
        [cdkDragDisabled]="item.static"
        cdkDragBoundary=".visionboard-workspace-selected-items"
        (cdkDragStarted)="onDragStart($event, item)"
        (cdkDragReleased)="onDragReleased($event, item)"
        (cdkDragMoved)="onDragMoved($event, item)"
        [dragging]="dragging"
        [externalDrag]="externalDrag"
        [removable]="true"
        (removed)="onItemRemoved($event)"
        [ngClass]="{ hideItems: hideItems }"
      ></app-visionboard-workspace-item>
    </div>
  </div>
</div>
